export const fieldNames = {
  dueDate: 'dueDate',
  amount: 'amount',
  quoteDays: 'quoteDays',
  clientApproval: 'clientApproval',
  isExtConsultantEngaged: 'isExtConsultantEngaged',
  isECReportReceived: 'isECReportReceived',
  jobDueDateInModal: 'jobDueDateInModal',
};
